export function getAllReservedBotIds(existingBotIds: string[], otherReservedBotIds: string[]) {
  return [...existingBotIds, ...otherReservedBotIds].flatMap(id => [id, `${id}-test`])
}
